import React from 'react'

const RowSkelton = () => {
  return (
    <div className='flex flex-col gap-2 px-4 my-2'>
         <div className="skeleton lg:h-8 h-6 w-full"></div>
    </div>
  )
}

export default RowSkelton